import { render } from "./add-grade-step-to-remont.vue?vue&type=template&id=6ede307a&scoped=true"
import script from "./add-grade-step-to-remont.vue?vue&type=script&lang=js"
export * from "./add-grade-step-to-remont.vue?vue&type=script&lang=js"

import "./add-grade-step-to-remont.vue?vue&type=style&index=0&id=6ede307a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ede307a"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QTr from 'quasar/src/components/table/QTr.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QLinearProgress,QCardSection,QBtn,QIcon,QCardActions,QTr});qInstall(script, 'directives', {ClosePopup});
